// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CTA_Wrapper___UdDd","Card":"CTA_Card__TusUd","Title":"CTA_Title__p_fzI"};